import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-cream py-12 border-t-4 border-warm-brown" data-id="element-109">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-111">
          <div className="mb-6 md:mb-0 text-center md:text-left" data-id="element-112">
            <h2 className="font-serif text-2xl tracking-widest uppercase mb-2" data-id="element-113">
              Freddie Cheah
            </h2>
            <p className="text-gray-400 text-sm tracking-widest uppercase" data-id="element-114">
              Asian Fusion
            </p>
          </div>

          <div className="flex space-x-6 mb-6 md:mb-0" data-id="element-115">
            <a href="#" className="text-gray-400 hover:text-amber transition-colors" data-id="element-116">
              Instagram
            </a>
            <a href="#" className="text-gray-400 hover:text-amber transition-colors" data-id="element-117">
              Facebook
            </a>
            <a href="#" className="text-gray-400 hover:text-amber transition-colors" data-id="element-118">
              Yelp
            </a>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-119">
          <p data-id="element-120">
            &copy; {new Date().getFullYear()} Freddie Cheah. All rights
            reserved.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-121">Paducah, Kentucky</p>
        </div>
      </div>
    </footer>;
}